import styled, { css } from "styled-components";

export const StyledScrollArea = styled.div`
   max-height: 100%;
   overflow-y: auto;
`;

export const StyledScrollAreaContent = styled.div`
   overflow-x: hidden;
   height: 100%;
   ${({ maxHeight }) => maxHeight && css`
      max-height: ${`${maxHeight}px`}
   `};
   /* width: ${({scrollBarSize}) => scrollBarSize ? `calc(100% - ${scrollBarSize}px)` : '100%'}; */
`;